import { Pipe, PipeTransform } from '@angular/core';
import { StudyFile } from 'src/app/models/Study/study-file.model';
import { MediaCategory } from 'src/app/models/media/media-category.model';

@Pipe({
  name: 'filterStudyFilesForGroupAndSide',
  pure: false,
})
export class FilterStudyFilesByGroupPipe implements PipeTransform {
  transform(
    studyFiles: StudyFile[],
    mediaGroupId: number,
    mediaCategories: MediaCategory[],
    isRightSide: boolean = false
  ): any {
    return studyFiles
      .filter((studyFile) => studyFile.mediaGroupId === mediaGroupId)
      .filter((studyFile) => {
        const category = mediaCategories.find(
          (mc) => mc.id === studyFile.mediaCategoryId
        );

        return category.name
          .toLowerCase()
          .includes(isRightSide ? 'right' : 'left');
      });
  }
}
